import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Button } from "../../components/RegularComponents";

export const RoleWithRJSCQuestionView = (props) => {
  const dispatch = useDispatch();

  const handleNext = (hasRoleWithRJSC) => () => {
    // dispatch(setHasRoleWithRJSC(hasRoleWithRJSC))

    const nextPath = hasRoleWithRJSC
      ? ROUTE_PATH.MRA_HAS_WORK_EXPERIENCE
      : ROUTE_PATH.MRA_HAS_ROLE_WITH_RJSC_NO;
    dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`));
  };
  const regOfJointCompaniesURL = "https://rjsc.novascotia.ca/";

  return (
    <div className="container">
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>Your role at your company</h1>
        </div>
      </div>

      {/* Information Paragraphs */}
      <div className="row">
        <div className="col-lg-9">
          <p>
            As the principal broker for your brokerage, you must have one of the
            following roles at your company: director, partner, officer, or sole
            proprietor.
          </p>
          <p>
            Most companies in Nova Scotia are listed in the Registry of Joint
            Stock Companies. If you aren't sure of your role, you can find your
            company profile in the{" "}
            <a href={regOfJointCompaniesURL}>Registry of Joint Stock Companies (RJSC)</a>.
          </p>
          <p>Are you a director, partner, officer or sole proprietor?</p>
        </div>
      </div>
      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-2">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
